import React from 'react'
import Card from './card';
import foods from "../Restaurant-menu/resturant-menu-data/menuItems";

const menu = () => {
  return (<>
      <h1 className='text-3xl text-primary text-center font-bold'>Checkout Our 3D Menu</h1>
        <div className='flex flex-col items-center  justify-center md:flex-row shrink-0 gap-8 p-16'>
        {foods.slice(0, -1).map((card) => (
            <Card key={card.id} src={card} title={card.title} price={card.price} desc={card.category} />
        ))}
        </div>
    </>
  )
}

export default menu